import { render, staticRenderFns } from "./siteBlocker.vue?vue&type=template&id=edfe6f36"
import script from "./siteBlocker.vue?vue&type=script&lang=js"
export * from "./siteBlocker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports